/**
 * Returns true when the relative Call Center API path is calling-related
 * and should be blocked when organization calling is disabled.
 *
 * @param {string|undefined|null} url
 */
export const isCallingRelatedApiUrl = (url) => {
  const path = String(url || "")
    .replace(/^\/+/, "")
    .split("?")[0]
    .toLowerCase();

  if (path === "campaigns" || path.startsWith("campaigns/")) {
    return true;
  }
  if (path === "calls" || path.startsWith("calls/")) {
    return true;
  }
  if (path === "telephony" || path.startsWith("telephony/")) {
    return true;
  }
  return false;
};
